var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import cx from 'classnames';
import styles from './Drawer.css';
import BaseDrawer from './v2/BaseDrawer';
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer(props) {
        var _this = _super.call(this, { noScrollClassName: styles['no-scroll'] }) || this;
        _this.drawerShown = false;
        _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
        _this.stopProcess = _this.stopProcess.bind(_this);
        return _this;
    }
    Drawer.prototype.UNSAFE_componentWillReceiveProps = function (nextprops) {
        if (nextprops.show !== this.props.show) {
            if (nextprops.show) {
                requestAnimationFrame(this.lockBodyScroll);
            }
            else {
                requestAnimationFrame(this.unlockBodyScroll);
            }
        }
    };
    Drawer.prototype.handleOverlayClick = function (e) {
        this.props.toggle && this.props.toggle();
        e.stopPropagation();
    };
    Drawer.prototype.stopProcess = function (e) {
        e.stopPropagation();
    };
    Drawer.prototype.componentDidUpdate = function () {
        var _this = this;
        setTimeout(function () {
            _this.drawerShown = _this.props.show;
        }, 120);
    };
    Drawer.prototype.render = function () {
        var contentClass = {}, overlayClass = {};
        overlayClass[styles['overlayShown']] = this.props.show;
        overlayClass[styles['overlay']] = true;
        overlayClass[styles['showHeader']] = this.props.showHeader;
        overlayClass[styles['drawerOverlayHidden']] = !this.props.show;
        contentClass[styles['cardHidden']] = this.drawerShown && !this.props.show;
        contentClass[styles['cardShown']] = this.props.show;
        contentClass[styles['content']] = true;
        contentClass[this.props.contentClass] = this.props.contentClass !== undefined;
        return (<div className={styles['fk-dialog-drawer']} key="dialog">
				<div className={cx(overlayClass)} ref="overlay" onClick={this.handleOverlayClick}>
					<div className={cx(contentClass)} onClick={this.stopProcess} id="bottom-sheet-content">
						<div className={styles['children']}>{this.props.children}</div>
					</div>
				</div>
			</div>);
    };
    return Drawer;
}(BaseDrawer));
export default Drawer;
